// use named export in './index'
export default {
  REWARDS_BANNER_LINK_CLICKED: 'Rewards Banner Link Clicked',
  REWARDS_BANNER_CLOSED: 'Rewards Banner Closed',
  EXISTING_USER_EXPERIENCE_REWARDS_PROGRAM_CALLOUT_LINK_CLICKED:
    'Learn More Link Clicked',
  EXISTING_USER_EXPERIENCE_REWARDS_PROGRAM_CALLOUT_CLOSED: 'Callout Closed',
  RECOMMENDED_BOX_SELECTED: 'Recommendations Page Box Selected',
  RECOMMENDED_PRODUCT_SELECTED: (selected: boolean) =>
    `Recommendations Page Product ${selected ? 'Deselected' : 'Selected'}`,
  RECOMMENDATIONS_CARD_CLICKED: 'Recommendation Card Clicked',
  RECOMMENDATIONS_INGREDIENTS_MODAL_OPENED: 'Ingredients Modal Opened',
};
